// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1tq3I","header":"PatientBlock_header__1MYMl","label":"PatientBlock_label__1zK39","option":"PatientBlock_option__3wOKS"};